module.exports = __webpack_public_path__ + "static/media/g2.f9835bb7.jpg";